/**
 * Google Analytics utility – mirrors Angular's google.analytics.ts.
 * IDs are read from env vars: VITE_GA_ID (staging) and VITE_GA_ID_PROD (prod).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

function isDev(): boolean {
  return import.meta.env.DEV
}

/**
 * Send a Google Analytics event.
 * @param eventAction - Event action (e.g. 'autosave', 'click')
 * @param eventCategory - Event category (e.g. 'resident application info')
 * @param eventLabel - Event label (e.g. applicant ID)
 */
export function sendAnalytics(
  eventAction?: string,
  eventCategory?: string,
  eventLabel?: string | number | null
): void {
  if (isDev()) return
  if (typeof window.gtag !== 'function') return
  window.gtag('event', eventAction, {
    event_category: eventCategory,
    event_label: String(eventLabel ?? ''),
  })
}
